let Base64 = require('js-base64').Base64;
// 1 Base64.encode(明文)  
// 2 Base64.decode(密文)

export function calculation (state,val){
	console.log(state,val)
	if(state){
		if(typeof val === 'object'&&val.length > 0){
			return ''
		}else if(typeof val === 'string'&&val){
			return ''
		}else if(typeof val === 'number'&&val>=0){
			return ''
		}else if(typeof val === 'boolean'&&val){
			return ''
		} else{
			return 'warp_red'
		}
	}
}
/**
 * base64加密 
 * typestr 地址
 * objson  傳參
 */
export function axoisfix (typestr='client_auth',objson={},msgnum='9833BAC36DB7410DAB4896F4657660EE',lang='big5'){
	console.log(objson)
	let objstr = '';
	for(let key in objson){
		objstr += '<'+key+'>'+objson[key]+'</'+key+'>';
	}
	let str = '<message type="'+typestr+'"  msgnum="'+msgnum+'" language="'+lang+'">'+ objstr +'</message>'
	console.log(str)
	return Base64.encode(str)
}
